import { yupResolver } from "@hookform/resolvers/yup"
import { faBoxOpen } from "@jewlr/pro-light-svg-icons/faBoxOpen"
import { FloatInput } from "@jewlr/storybook/form"
import PropTypes from "prop-types"
import { useState } from "react"
import { useForm, Controller } from "react-hook-form"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import isEmail from "validator/lib/isEmail"
import * as Yup from "yup"

import { subscribeNotification } from "areas/product/store/actions"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { cn } from "styles/utils"

const CTA = ({ ...props }) => (
  <Button
    className="mt-16 w-full rounded-sm font-bold"
    variant="primary"
    {...props}
  />
)

const Msg = ({ success = false, ...props }) => (
  <p
    className={cn(
      "text-14 tracking-tigher",
      success ? "text-green-darker" : "text-error"
    )}
    {...props}
  />
)

Msg.propTypes = {
  success: PropTypes.bool,
}

const schema = Yup.object().shape({
  email: Yup.string()
    .required("Please enter your email.")
    .test("test-email", "Please enter your email.", (value) =>
      isEmail(value || "")
    ),
})

const OutOfStockForm = ({ outOfStockRef, subscribeNotification }) => {
  const [success, setSuccess] = useState(false)

  const {
    control,
    formState: { errors, isSubmitting },
    handleSubmit,
    setError,
  } = useForm({
    defaultValues: {
      email: "",
    },
    mode: "onBlur",
    resolver: yupResolver(schema),
  })

  const onSubmit = async ({ email }) => {
    try {
      setSuccess(false)

      await new Promise((res, rej) => {
        subscribeNotification(email, {
          onError: (err) => rej(err),
          onSuccess: () => {
            setSuccess(true)
            res()
          },
        })
      })
    } catch (err) {
      setError("root.error", {
        message: err?.errors?.[0] || err?.message || err,
      })
    }
  }

  return (
    <div
      className="tablet:bg-grey-4 tablet:rounded-none tablet:py-24 tablet:mb-20 mb-10 rounded-xl bg-white px-24 py-28 text-center"
      ref={outOfStockRef}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-10 flex items-center justify-center">
          <FontAwesomeIcon
            className="text-24 mr-6 text-black"
            icon={faBoxOpen}
          />
          <p className="text-20 tracking-tigher font-bold text-black">
            OUT OF STOCK
          </p>
        </div>
        <p className="text-grey-65 text-14 tracking-tigher leading-16 pb-12">
          Sign up! We&apos;ll notify you when this item is back.
        </p>
        {success ? (
          <>
            <Msg success>Success! We&apos;ll be in touch soon.</Msg>
            <CTA asChild>
              <Link to="/new-items">Shop New Items</Link>
            </CTA>
          </>
        ) : (
          <>
            {errors?.root?.error && <Msg>{errors.root.error.message}</Msg>}
            <div className="pt-8 text-left">
              <Controller
                control={control}
                name="email"
                render={({ field, fieldState: { error } }) => (
                  <FloatInput
                    autoComplete="email"
                    data-cy="out-of-stock-email"
                    error={error}
                    label="Enter Your Email"
                    placeholder="Enter Your Email"
                    type="email"
                    variant="checkout"
                    {...field}
                  />
                )}
              />
            </div>
            <CTA disabled={isSubmitting} loading={isSubmitting} type="submit">
              {!isSubmitting && "Notify Me When Available"}
            </CTA>
          </>
        )}
      </form>
    </div>
  )
}

OutOfStockForm.propTypes = {
  outOfStockRef: PropTypes.object,
  subscribeNotification: PropTypes.func,
}

const mapStateToProps = () => ({})

const mapDispatchToProps = (dispatch) => {
  return {
    subscribeNotification: (email, actions) =>
      dispatch(subscribeNotification(email, actions)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OutOfStockForm)
